var vms = vms || {};
vms.page = vms.page || {};


vms.page.lxHint = function () {
    this.xOffset = 0; // x distance from mouse
    this.yOffset = 10; // y distance from mouse
    jQuery(".lx-hint-container").hover(function (e) {
        var insideText = jQuery(".lx-hint", this).html();
        this.top = (e.pageY + yOffset);
        this.left = (e.pageX + xOffset);
        $('body').append('<div id="lxHint" style="overflow:hidden;" class="tooltip">' + insideText + '</div>');
        $('div#lxHint').css("top", this.top + "px").css("left", this.left + "px").delay(100).fadeIn("fast");
    },
        function () {
            jQuery("div#lxHint").fadeOut("false").remove();
        }).mousemove(
            function (e) {
                this.top = (e.pageY + yOffset);
                this.left = (e.pageX + xOffset);
                jQuery("div#lxHint").css("top", this.top + "px").css("left", this.left + "px");
            }
        );
}


vms.page.toggleContentWidth = function () {
    if ($("#uOneCol").css("width") == "960px") {
        $("#uOneCol").css("width", "100%");
    } else {
        $("#uOneCol").css("width", "");
    }
    $(".lx-feedback").toggle();
}


vms.page.loading = function (pUrl) {
    $("body").append('<div class="vsmLoading"><div><span>LOADING</span><br/>Please wait</div></div>');
    if (pUrl) setTimeout(function () { apex.navigation.redirect(pUrl); }, 1);

}
vms.page.loadingRemove = function () {
    $(".vsmLoading").remove();
}

vms.page.saving = function (pUrl) {
    $("body").append('<div class="vsmLoading saving"><div><span>SAVING</span><br/>Please wait</div></div>');
    if (pUrl) setTimeout(function () { apex.navigation.redirect(pUrl); }, 1);

}
vms.page.savingRemove = function () {
    $(".vsmLoading").remove();
}

var lxHint = vms.page.lxHint;
var toggleContentWidth = vms.page.toggleContentWidth;
var vsmLoad = vms.page.loading;
var vsmLoadRemove = vms.page.loadingRemove;
